// 美豆剩余

import React from 'react';
import Modal from '@/components/modal';
import meidouBean from '@/assets/image/meidou/meidou-bean.png';
import meidouEmpty from '@/assets/image/meidou/meidou-empty.png';

import styles from './index.module.css';
import { useAtom } from 'jotai';
import {
  dayNumListAtom,
  meidouForeverTotalAtom,
  vipInfoAtom,
  visibleMeidouInfoModalAtom,
} from '@/store';
import { track } from '@/utils/common';

const MeidouCountInfoModal = () => {
  const [vipInfo] = useAtom(vipInfoAtom);
  const [dayNumList] = useAtom(dayNumListAtom);
  const [meidouForeverTotal] = useAtom(meidouForeverTotalAtom);

  const [visibleMeidouInfoModal, setVisibleMeidouInfoModal] = useAtom(visibleMeidouInfoModalAtom);

  return (
    <Modal
      visible={visibleMeidouInfoModal}
      width={320}
      onClose={() => setVisibleMeidouInfoModal(false)}
      style={{
        backgroundColor: '#181A1C',
      }}
    >
      <div className={styles.meidouCountWrap}>
        <div className={styles.meidouCountTitle}>剩余美豆</div>
        <div className={styles.meidouCountDesc}>
          优先消耗临期美豆&nbsp;&nbsp;
          <span
            onClick={() => {
              window.open('https://www.designkit.cn/meidou-introduce');
              track({
                event_id: 'vip_page_click',
                event_name: '会员落地页点击',
                params: {
                  class: 'introduce',
                },
              });
            }}
          >
            美豆介绍 &gt;
          </span>
        </div>
        <div className={styles.meidouCountBody}>
          {dayNumList.length || meidouForeverTotal ? (
            <>
              {meidouForeverTotal > 0 ? (
                <div className={styles.meidouCountTotal}>
                  <span className={styles.meidouCountDay}>永久有效</span>
                  <span className={styles.meidouCountNum}>
                    <img width={24} height={24} src={meidouBean} alt="" />
                    {meidouForeverTotal}
                  </span>
                </div>
              ) : null}
              {dayNumList.length ? (
                <div className={styles.meidouCountList}>
                  {dayNumList.map((v, index) => {
                    return (
                      <div className={styles.meidouCountItem} key={index}>
                        <span className={styles.meidouCountDay}>{v.day}天过期</span>
                        <span className={styles.meidouCountNum}>{v.num}</span>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </>
          ) : (
            <div className={styles.meidouCountEmpty}>
              <img src={meidouEmpty} alt="" />
              <p>没有美豆哦～请前往购买吧</p>
            </div>
          )}
        </div>

        <div className={styles.meidouBtn} onClick={() => setVisibleMeidouInfoModal(false)}>
          好的
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(MeidouCountInfoModal);
